module.exports = __webpack_public_path__ + "static/media/video-placeholder.6fc0459e.jpg";